import { render, staticRenderFns } from "./PatientTransferModal.vue?vue&type=template&id=ff57d32a&scoped=true"
import script from "./PatientTransferModal.vue?vue&type=script&lang=js"
export * from "./PatientTransferModal.vue?vue&type=script&lang=js"
import style0 from "./PatientTransferModal.vue?vue&type=style&index=0&id=ff57d32a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff57d32a",
  null
  
)

export default component.exports